module.exports = __webpack_public_path__ + "static/media/10.5b4ef134.jpg";